import { render, staticRenderFns } from "./Select-Supplier.vue?vue&type=template&id=5fd534b4&scoped=true"
import script from "./Select-Supplier.vue?vue&type=script&lang=js"
export * from "./Select-Supplier.vue?vue&type=script&lang=js"
import style0 from "./Select-Supplier.vue?vue&type=style&index=0&id=5fd534b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd534b4",
  null
  
)

export default component.exports